import React from 'react';

import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
// import './index.css';
import App from './App';
// import reportWebVitals from './reportWebVitals';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import { UserContextProvider } from './context/userContext';
import store, { persistor } from './redux/store';
import { BrowserRouter as Router } from 'react-router-dom';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { PersistGate } from 'redux-persist/integration/react';
import ErrorBoundary from './components/error-boundary';
import { markWebviewMilestone, trackWebviewMilestone } from './utils/postMessage';

// First thing the bundle does: say it arrived. Separates "HTML loaded but the JS never
// came" from "JS came but React never mounted" on the landing timeline.
markWebviewMilestone('bundle');
trackWebviewMilestone('Webview Bundle Loaded');


const queryClient = new QueryClient();

const rootElement = document.getElementById('root');
// No onUncaughtError/onCaughtError/onRecoverableError overrides: React's
// defaults already log these to the console, which is what we want now that
// nothing forwards them to a remote collector.
const root = ReactDOM.createRoot(rootElement);
rootElement.setAttribute('notranslate', true);
root.render(
	<React.StrictMode>
		<QueryClientProvider client={queryClient}>
			<Provider store={store}>
				<PersistGate loading={null} persistor={persistor}>
					<UserContextProvider>
						<Router>
							<ErrorBoundary>
								<App />
							</ErrorBoundary>
						</Router>
					</UserContextProvider>
				</PersistGate>
			</Provider>
		</QueryClientProvider>
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
